import React from "react";
import { useDispatch } from "react-redux";
import { Button } from "@mui/material";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import IconRemove from "src/assets/images/icon_remove.svg";
import { unlistProject } from "src/thunks/clientProjects";
import toastMessages from "src/constant/toastMessages.json";
import { toast } from "react-toastify";
import { GetError } from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";

export const UnlistProjectForm = ({ setIsUnlistProject, getAllData, selectedProjectManagersRow }) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();

  /** handler functions--------------------------------------------------- **/
  const handleUnlistProjectModalClose = () => {
    setIsUnlistProject(false);
  };

  /** Function to handle the action of unlisting a project ------------------ **/
  const handleUnlistProject = async () => {
    try {
      let result = await dispatch(
        unlistProject({ ...selectedProjectManagersRow })
      ).unwrap();
      getAllData();
      handleUnlistProjectModalClose();
      if (result) {
        setTimeout(() => {
          dispatch(getAllNofificationForDashboard(1, 20));
        }, 2000);
        toast.success(toastMessages.ProjectUnlisted);
      }
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  return (
    <>
      <div>
        <div className="depot-form-header-style">
          <span className="allocate-mgnr-header-color me-2">UNLIST</span>
          <span className="allocate-mgnr-subheader-color">
            {selectedProjectManagersRow.clientName} /{" "}
            {selectedProjectManagersRow.name}
          </span>
        </div>
        <div style={{ paddingLeft: 100, paddingRight: 100 }}>
          <div className="d-flex flex-column" style={{ marginTop: 100 }}>
            <span className="depotManagerName-style common-text-for-removeDepotManager">
              {selectedProjectManagersRow.name}
            </span>
            <span className="removeDepotManager-text-removed common-text-for-removeDepotManager">
              project will be unlisted{" "}
            </span>
            <span className="long-text-style-unlist-depot project-name-unlist-style mb-4">
              from {selectedProjectManagersRow.clientName}
            </span>
            <span className="long-text-style-unlist-depot mb-2">
              This action cannot be undone.
            </span>
            <span className="long-text-style-unlist-depot mb-2">
              This does not delete any data.
            </span>
            <span className="long-text-style-unlist-depot mb-2">
              This project will still show up in old records / search results
              where relevant and can be viewed.
            </span>
            <span className="long-text-style-unlist-client">
              Cannot be unlisted as long as there are items in the depot
              allocated to this project.
            </span>
          </div>

          <div className="d-flex flex-column" style={{ marginTop: 100 }}>
            <span className="mb-3 confirm-msg-for-removeDepotManager">
              Are you sure you want to proceed?
            </span>
            <div className="d-flex flex-row">
              <Button
                variant="outlined"
                className="btn-bootstrap-submit-style"
                startIcon={
                  <img
                    src={IconLeftArrow}
                    width={15}
                    height={15}
                    alt="new"
                  ></img>
                }
                onClick={handleUnlistProjectModalClose}
                type="submit"
              >
                No, Go Back
              </Button>

              <Button
                onClick={() => handleUnlistProject()}
                variant="outlined"
                className="btn-bootstrap-submit-style ms-3"
                style={{ color: "red", borderColor: "red" }}
                startIcon={
                  <img src={IconRemove} width={15} height={15} alt="new"></img>
                }
              >
                Yes, Unlist Project
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
